<template>
  <form class="f-row search-bar" @submit.prevent="handleSearch">
    <label class="f-row ctr search-container" :for="labelId">
      <span class="hidden">Pesquisa</span>
      <input :id="labelId" type="search" placeholder="Pesquisa" v-model="value" autocomplete="off" />
      <button>
        <Icon icon="search" />
      </button>
    </label>
  </form>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      value: ""
    };
  },
  computed: {
    labelId() {
      return this.$options._scopeId;
    }
  },
  methods: {
    handleSearch() {
      this.value = "";
    }
  }
};
</script>

<style scoped>
.search-bar {
  width: 210px;
  margin: 10px;
}

.search-container {
  width: 100%;
  border-radius: 0.25rem;
  background: #485868;
}

.search-container > input {
  width: 100%;
  padding: 10px 0 10px 10px;
  font-size: 14px;
  color: #eee;
  background: none;
}

.search-container > input::placeholder {
  color: #ccc;
}

.search-container > input::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.search-container > button {
  padding: 10px;
  color: #eee;
  background: none;
}
</style>